import { Select as AntdSelect }       from 'antd';
import React                          from 'react';
import { injectIntl }                 from 'react-intl';
import type { WrappedComponentProps } from 'react-intl';

interface IntlSelectProps extends WrappedComponentProps {
  children?: React.JSX.Element | React.JSX.Element[];
  placeholder?: any;
}

class IntlSelect extends React.Component<IntlSelectProps> {
  public static Option = AntdSelect.Option;

  public render() {
    const allProps: any = {
      ...this.props,
    };

    if (!!this.props.placeholder && typeof this.props.placeholder === 'string') {
      allProps.placeholder = this.props.intl.formatMessage({
        id: this.props.placeholder || ' ',
      });
    }

    return <AntdSelect {...allProps}>{this.props.children}</AntdSelect>;
  }
}

interface SelectType extends React.ComponentClass<any, any> {
  Option: React.FC<any>;
}

export default injectIntl(IntlSelect) as unknown as SelectType;
